import { Component } from "@angular/core";
import { RouterLink, RouterOutlet } from "@angular/router";
import { TestSelectorsModule } from "./test-selectors/test-selectors.module";

@Component({
  selector: "app-root",
  standalone: true,
  imports: [RouterOutlet, RouterLink, TestSelectorsModule],
  templateUrl: "./app.component.html",
  styleUrl: "./app.component.scss",
})
export class AppComponent {
  title = "Student Forms";
  currentYear = new Date().getFullYear();
}
